{
  "morning": "Good morning",
  "afternoon": "Good afternoon",
  "evening": "Good evening",
  "welcome": "Welcome",
  "manageDescription": "Manage your invoices, providers, and payments from here.",
  "quickLinks": "Quick Links",
  "nav": {
    "dashboard": "Dashboard",
    "invoices": "Invoices",
    "addresses": "Addresses",
    "actions": "Actions",
    "analytics": "Analytics",
    "settings": "Settings",
    "payment": "Payment",
    "meterReadings": "Meter Readings",
    "adminSettings": "Admin Settings",
    "main": "Main",
    "tools": "Tools",
    "admin": "Admin"
  },
  "button": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "submit": "Submit",
    "back": "Back",
    "close": "Close",
    "retry": "Retry",
    "logout": "Logout"
  },
  "label": {
    "email": "Email",
    "password": "Password",
    "name": "Name",
    "status": "Status",
    "provider": "Provider",
    "address": "Address",
    "date": "Date",
    "amount": "Amount",
    "username": "Username",
    "accountKeyword": "Keyword before the account (IBAN)",
    "skipPayment": "Skip payment",
    "taxDeduction": "Tax deduction"
  },
  "placeholder": {
    "email": "you@example.com",
    "password": "••••••••",
    "yourName": "Your name",
    "providerName": "Provider name",
    "addressName": "Address name",
    "username": "Username",
    "accountKeyword": "e.g. Account:, IBAN:",
    "otpCode": "Enter OTP code",
    "passwordNew": "New password (leave blank to keep)",
    "passwordExisting": "Password",
    "taxDeductionAmount": "Tax deduction amount (KM)",
    "fromDate": "From",
    "toDate": "To"
  },
  "status": {
    "pending": "Pending",
    "processing": "Processing",
    "paid": "Paid",
    "completed": "Completed",
    "failed": "Failed",
    "skipped": "Skipped"
  },
  "message": {
    "loading": "Loading...",
    "somethingWentWrong": "Something went wrong",
    "unexpectedError": "An unexpected error occurred.",
    "reloadPage": "Reload page",
    "registrationDisabled": "Registration is disabled",
    "noInvoicesFound": "No invoices found",
    "noProvidersYet": "No providers yet",
    "noAddressesYet": "No addresses yet",
    "pageNotFound": "Page not found",
    "goToDashboard": "Go to Dashboard"
  },
  "form": {
    "signIn": "Sign in",
    "signingIn": "Signing in...",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "createAccount": "Create account",
    "creatingAccount": "Creating account...",
    "save": "Save",
    "saving": "Saving...",
    "confirmPay": "Confirm & Pay",
    "changeStatus": "Change Status",
    "downloadPdf": "Download PDF",
    "assignProvider": "Assign Provider",
    "assign": "Assign",
    "remove": "Remove",
    "addAddress": "Add Address",
    "editAddress": "Edit Address",
    "editProvider": "Edit Provider"
  },
  "dashboard": {
    "welcome": "Welcome",
    "manageDescription": "Manage your invoices, providers, and payments from here.",
    "totalInvoices": "Total Invoices",
    "totalPaid": "Total Paid",
    "pendingProcessing": "Pending / Processing",
    "avgMonthly": "Avg Monthly",
    "quickLinks": "Quick Links"
  },
  "payment": {
    "processing": "Payment Processing",
    "complete": "Payment complete",
    "history": "Payment History",
    "twoFaRequired": "2FA Required",
    "enterOtp": "Enter OTP code",
    "progress": "Processing {{count}} of {{total}} invoice(s)",
    "progressDot": "Processing {{count}} of {{total}} invoice(s)...",
    "cancel": "Cancel"
  },
  "scraping": {
    "title": "Scraping",
    "start": "Start Scraping",
    "inProgress": "Scraping in progress...",
    "clearLogs": "Clear Logs",
    "back": "Back"
  },
  "settings": {
    "title": "Settings",
    "discord": "Discord",
    "bank": "Bank (ASA)",
    "notifications": "Notifications",
    "channel": "Channel",
    "payment": "Payment",
    "configuredViaEnableDiscord": "Configured via ENABLE_DISCORD",
    "configuredViaDiscordChannel": "Configured via DISCORD_CHANNEL",
    "configuredViaPaymentEnabled": "Configured via PAYMENT_ENABLED",
    "maskedValue": "••••••••"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "show": "Show",
    "perPage": "per page",
    "range": "Showing {{start}}–{{end}} of {{total}}"
  },
  "error": {
    "failedToSave": "Failed to save",
    "failedToDelete": "Failed to delete",
    "failedToAssign": "Failed to assign",
    "failedToRemove": "Failed to remove",
    "failedToUpdate": "Failed to update",
    "failedToLoadPaymentHistory": "Failed to load payment history",
    "registrationFailed": "Registration failed",
    "loginFailed": "Login failed",
    "connectionFailed": "Connection failed",
    "noInvoicesToPay": "No invoices to pay",
    "paymentFailed": "Payment failed",
    "paymentCancelled": "Payment cancelled"
  },
  "app": {
    "title": "Platko",
    "logo": "Platko"
  },
  "language": {
    "english": "English",
    "bosnian": "Bosnian"
  },
  "theme": {
    "switchToDark": "Switch to dark mode",
    "switchToLight": "Switch to light mode"
  },
  "confirm": {
    "deleteAddress": "Delete this address?"
  },
  "empty": {
    "noSpendingData": "No spending data yet",
    "noProviderData": "No provider data yet",
    "noStatusData": "No status data yet",
    "noAddressData": "No address data yet",
    "chartsHint": "Run scraping to generate data. Charts appear after the first import.",
    "noPaymentLogs": "No payment logs yet.",
    "noMessages": "No messages for this job.",
    "waitingForLogs": "Waiting for logs..."
  },
  "card": {
    "startScraping": "Start Scraping",
    "startScrapingDesc": "Trigger invoice scraping for all addresses and providers.",
    "viewLiveLogs": "View Live Logs",
    "processPayments": "Process Payments",
    "processPaymentsDesc": "Review and process pending invoices for payment.",
    "viewPendingInvoices": "View Pending Invoices"
  },
  "table": {
    "invoiceDate": "Invoice Date",
    "createdAt": "Created At",
    "address": "Address",
    "provider": "Provider",
    "amount": "Amount",
    "status": "Status",
    "actions": "Actions",
    "name": "Name",
    "afterPayment": "After Payment",
    "created": "Created",
    "datePaid": "Paid"
  },
  "detail": {
    "date": "Date",
    "createdAt": "Created At",
    "amount": "Amount",
    "status": "Status",
    "address": "Address",
    "provider": "Provider",
    "reference": "Reference",
    "account": "Account",
    "datePaid": "Paid date",
    "age": "Age",
    "taxDeduction": "Tax deduction",
    "skipPayment": "Payment"
  },
  "back": {
    "invoices": "Back to Invoices"
  },
  "logGroup": {
    "bankLogin": "Bank Login",
    "processingInvoice": "Processing invoice"
  },
  "paymentLog": {
    "simulated": "Simulated",
    "invoices": "invoices",
    "clickToViewLogs": "Click to view logs",
    "details": "Payment Log Details",
    "completed": "Completed",
    "failed": "Failed",
    "cancelled": "Cancelled",
    "running": "Running",
    "messages": "Messages",
    "entries": "Entries"
  },
  "pageTitle": "Page",
  "saveError": "Failed to save",
  "deleteConfirm": "Delete this?",
  "deleteError": "Failed to delete",
  "startScraping": "Start Scraping",
  "startScrapingDesc": "Trigger invoice scraping for all addresses and providers.",
  "viewLiveLogs": "View Live Logs",
  "processPayments": "Process Payments",
  "processPaymentsDesc": "Review and process pending invoices for payment.",
  "viewPendingInvoices": "View Pending Invoices",
  "confirmPay": "Confirm & Pay",
  "notSet": "Not set"
}
